<template>
  <section class="mobile-menu">
    <nav class="mobile-menu_nav">
      <router-link to="/" exact @click.native="closeMenu()" class="mobile-menu_nav-a">Home</router-link>
      <router-link to="/login" v-if="!isAuthorized" @click.native="closeMenu()" class="mobile-menu_nav-a" >Member Access</router-link>
      <router-link to="/login" v-if="!isAuthorized" @click.native="closeMenu()" class="mobile-menu_nav-a">Login</router-link>
      <router-link to="/register" v-if="!isAuthorized" @click.native="closeMenu()" class="mobile-menu_nav-a">Registration</router-link>
<!--      <router-link to="/about-us" v-if="!isAuthorized" @click.native="closeMenu()" class="mobile-menu_nav-a">About Us</router-link>-->
      <router-link to="/library" v-if="isAuthorized" @click.native="closeMenu()" class="mobile-menu_nav-a">Documents</router-link>
      <router-link to="/events" v-if="isAuthorized" @click.native="closeMenu()" class="mobile-menu_nav-a">Events</router-link>
      <router-link to="/gallery" v-if="isAuthorized" @click.native="closeMenu()" class="mobile-menu_nav-a">Gallery</router-link>
      <router-link to="/counsil" v-if="isAuthorized" @click.native="closeMenu()" class="mobile-menu_nav-a">Counsil Members</router-link>
      <router-link to="/contacts" @click.native="closeMenu()" class="mobile-menu_nav-a">Contact Us</router-link>
    </nav>
  </section>
</template>

<script>
export default {
  props: {
  isAuthorized:Boolean
  },
  data () {
    return {
    }
  },
  methods: {
    closeMenu() {
      this.active = false
      this.$emit('closeMenu', this.active);
    },
  },
}
</script>

<style lang="scss" scoped>
.mobile{
  &-menu{
    z-index: 5;
    overflow-x: hidden;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    width: 100vw;
    transform: translate(0, -100vh);
    background-color: #1a924a;
    transition: transform 450ms ease;
    padding-bottom: 44px;
    &_nav{
      margin-top: 105px;
      display: flex;
      flex-direction: column;
      text-align: center;
      &-active {
        color: #ffffff;
        font-family: "Open Sans";
        font-size: 14px;
        font-weight: 600;
        line-height: 48px;
        letter-spacing: 0.35px;
        text-decoration: none;
        outline: none;
        position: relative;
        margin:0 auto;
        &:after {
          visibility: visible;
          content: '';
          width: 100%;
          position: absolute;
          left: 0;
          bottom: 1px;
          border-width: 0 0 5px;
          border-style: solid;
          }
      }
      &-a{
        color: #ffffff;
        font-family: "Open Sans";
        font-size: 14px;
        font-weight: 400;
        line-height: 48px;
        letter-spacing: 0.35px;
        text-decoration: none;
        outline: none;
        position: relative;
        margin:0 auto;
        &:after {
          visibility: hidden;
          content: '';
          width: 100%;
          position: absolute;
          left: 0;
          bottom: 1px;
          border-width: 0 0 5px;
          border-style: solid;
          }
        }
      &_block {
        height: 5px;
        width: 10%;
        background-color: #ffffff;
      }
    }
  }
}
.active{
  transform: translatex(0);
  border-bottom-left-radius: 0; 
}
.active-link{
  transform: translatex(0) !important;
}
a.router-link-active, li.router-link-active>a {
  border-bottom: 4px solid white;
}
</style>
